/**
 * Twitter feed initialization.
 * 
 * @since 1.3.5
 * @param {type} $
 * @returns {undefined}
 */
(function($) { 
    'use strict';
    
    var EVENT_NAMESPACE = '.warta-wp.twittie';
    var EVENT = {
        CLICK: 'click' + EVENT_NAMESPACE
    };
    
    var $twitterWidgets = $('.twitter-feed');
    
    $twitterWidgets.each( function() {
        var $this = $(this);

        $this.twittie({
            username: $this.data('username'),
            apiPath: $this.data('api-path'),
            template: $this.find('script[type="text/template"]').html(),
            dateFormat: $this.data('date-format'),
            count: $this.data('count'),       
            loadingText: $this.data('loading-text')       
        });
    });   
    
    $twitterWidgets.on(EVENT.CLICK, 'a:has(.fa-reply)', function (event) {
        event.preventDefault();
        window.open($(this).attr('href'), '', 'width=710,height=540');
    });
})(jQuery);